import React, { useEffect, useState } from "react";
import Hero from "@/components/home/Hero";
import Manifesto from "@/components/home/Manifesto";
import Destinations from "@/components/home/Destinations";
import FeaturedExperiences from "@/components/home/FeaturedExperiences";
import PullQuote from "@/components/blocks/PullQuote";
import CTAStrip from "@/components/blocks/CTAStrip";
import { fetchExperiences } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { useSeo } from "@/lib/useSeo";

// TODO: Re-enable when catalog > 30 experiences.
// Temporarily hidden — with the current curated set the "Six, of twenty" grid
// felt sparse on the home. Everything below still fetches so flipping this to
// `true` restores the block instantly.
const SHOW_COLLECTION = false;

export default function Home() {
  const { lang, t } = useLang();
  const [experiences, setExperiences] = useState([]);

  useSeo({
    title:
      lang === "es"
        ? "Viaja de Verdad — Experiencias Singulares"
        : "Viaja de Verdad — Singular Experiences",
    description:
      lang === "es"
        ? "Veinte experiencias singulares en España, Italia y Portugal, curadas por Viaja de Verdad."
        : "Twenty singular experiences across Spain, Italy and Portugal, curated by Viaja de Verdad.",
    image: "/static/hero/hero-1-poster.jpg",
    locale: lang === "es" ? "es_ES" : "en_US",
    type: "website",
  });

  useEffect(() => {
    let cancelled = false;
    fetchExperiences({ lang })
      .then((data) => { if (!cancelled) setExperiences(data); })
      .catch((err) => {
        if (process.env.NODE_ENV === "development") {
          console.error("[VdV][Home] fetch failed:", err);
        }
      });
    return () => { cancelled = true; };
  }, [lang]);

  return (
    <div data-testid="home-page">
      <Hero />
      <Manifesto />
      <Destinations />
      {SHOW_COLLECTION && <FeaturedExperiences experiences={experiences} />}
      <PullQuote text={t.home.quote_text} attribution={t.home.quote_attr} bg="emerald" />
      <CTAStrip
        eyebrow={t.home.final_cta_eyebrow}
        headline={t.home.final_cta_main}
        italicTail={t.home.final_cta_italic}
        subtitle={t.home.final_cta_sub}
        buttonLabel={t.cta.explore}
        buttonTo="/experiences"
        image="/static/experiences/agrippa-baths-candlelight/hero.png"
        imageAlt="Candlelight dinner in the ancient Baths of Agrippa"
      />
    </div>
  );
}
